import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=1add178a&scoped=true"
import script from "./Credits.vue?vue&type=script&lang=js"
export * from "./Credits.vue?vue&type=script&lang=js"
import style0 from "./Credits.vue?vue&type=style&index=0&id=1add178a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1add178a",
  null
  
)

export default component.exports